<template>
  <ValidationObserver ref="careResponsibilities">
    <div>
      <h2 class="mb-5">
        Do you have any parenting/care responsibilities?
      </h2>
    </div>
    <ValidationProvider
      v-slot="{ errors }"
      name="careResponsibilities"
      rules="required"
    >
      <RadioButton
        v-model="careResponsibilities"
        @select="val => (careResponsibilities = val)"
        :options="options"
        mixed
        :selectedValue="careResponsibilities"
        :errorMessages="showValidationErrors ? errors : ''"
      />
    </ValidationProvider>

    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RadioButton from "@/components/common/RadioButton";
import { BOOLEAN_OPTIONS } from "@/constants/workers";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "CareResponsibilities",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    userDiversityTraits: Object
  },
  data() {
    return {
      options: includePreferNotSayOption(BOOLEAN_OPTIONS),
      careResponsibilities: this.userDiversityTraits.careResponsibilities,
      showValidationErrors: false
    };
  },
  methods: {
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.careResponsibilities.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: {
            careResponsibilities: getFormattedValue(this.careResponsibilities)
          },
          dataType: "divirsityTraits"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
